
  import { computed, defineComponent } from 'vue';
  import { useInspectionReport } from '@/ui/components/inspectionReport/useInspectioReport';

  interface EntityItemProps {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    item: {[key: string]: any};
  }

  export default defineComponent<EntityItemProps>({
    name: 'EntityItem',
    props: ['item'],
    setup() {
      const { resource } = useInspectionReport();
      const parsedEntityItem = computed(() => resource.value?.entity_items[resource.value?.entity_item]);

      return {
        parsedEntityItem,
      };
    },
  });
